// Curated project palette (DESIGN.md P2). These hues stay legible on both
// dark and light surfaces and read as distinct on charts.
export const PROJECT_COLORS = [
  "#e5484d", // red
  "#e5842b", // orange
  "#d9a400", // amber
  "#46a758", // green
  "#12a594", // teal
  "#0091ff", // blue
  "#3e63dd", // indigo
  "#8e4ec6", // violet
  "#e93d82", // pink
  "#8d8d8d", // slate
] as const;

export function randomColor(): string {
  return PROJECT_COLORS[Math.floor(Math.random() * PROJECT_COLORS.length)];
}
